import { Card, Space, Typography } from "antd";

import { FileForm } from "../components/FileForm";

const { Title } = Typography;

const CreateFile = () => {
  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Create File
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          File Information
        </Title>

        <FileForm mode="create" />
      </Card>
    </Space>
  );
};

export default CreateFile;
